<template>
  <div class="fangan">
    <div class="aa">
      <img class="log" src="/static/images/log2.jpg">
      <ul>
        <router-link v-for="(app,index) in navData" active-class='active' exact :key="index" tag='a' class="huanchongZhong yuanjiao description" :to="app.to">
          <li @click="closeRightBoxFun()">
            {{app.title}}
          </li>
        </router-link>
      </ul>
    </div>
<!--    <ui-footer :xuanfuBool="true"></ui-footer>-->
  </div>
</template>

<script>
import generalMix from '@/util/mix/general';
import Footer from '@/components/layout/Footer.vue';

export default {
  name: 'fangan',
  props:['obj','closeRightBoxFun'],
  mixins: [generalMix],
  data () {
    return {
      // 导航
      navData: [
        {to:'/','class':'icon-shouye','title':'首页'},
        {to:'/product','class':'icon-daohang2','title':'产品仓库'},
        {to:'/collect','class':'icon-wenjuan','title':'快速清单'},
        {to:'/ability','class':'icon-qinghuiyuan','title':'我的订单'},
        {to:'/team','class':'icon-wenjuan','title':'发票管理'},
        {to:'/advantage','class':'icon-wodeguanzhu','title':'个人信息'},
        {to:'/about','class':'icon-wodeguanzhu','title':'关于'},
        {to:'/article','class':'icon-wodeguanzhu','title':'资讯'},
        {to:'/login','class':'icon-wodeguanzhu','title':'登录'}
      ]
    }
  },
  components:{
    'ui-footer': Footer
  },
  methods:{
  },
  mounted() {
  },
  destroyed() {
  }
}
</script>

<style scoped lang='less'>

.fangan {
  box-shadow: 0 0 1.5rem rgba(18, 38, 63, .1);
  background: #FFFFFF;
  width: 480px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 0;
  border-radius: 1rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  overflow-y: hidden;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  padding-bottom: 10px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  div.aa{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex: 1;
    img.log{
      width: 160px;
    }
    ul{
      margin-top: 30px;
      li{
        line-height: 2.5em;
        border-bottom: 1px solid #EEEEEE;
        &:last-child{
          border: 0;
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .fangan {
    width: 80vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/daohang.vue